<!-- 交易服务主页面 -->
<template>
  <div class="biddinghall_w bc_F2F2F2">
    <div class="content_w">
      <div class="site_content">
        <div class="top_w">
          <div class=" d_flex align_item_c">
            <SiteBreadcrumb />
            <div
              v-for="item in dynamicTabs"
              :key="item.tabType"
              style="margin-left:10px"
              class="dynamic_tabs_w d_flex "
            >
              <div class="d_tab_i bc_fff fz12 c_1A1A1A">
                <span class="span_1">{{ item.value }}</span>
                <i
                  class="icon_i el-icon-close"
                  @click="setDynamicTabsVal(item.tabType)"
                />
              </div>
            </div>

            <div class="div_3 d_flex justify_content_sb align_item_c">
              <span
                class="fz12 c_1A1A1A"
              >（共{{ serviceMerchantDataRes.total }}条服务商信息）</span>
              <span
                class="span_2 fz12 c_1A1A1A bc_fff cursor_pointer"
                @click="clearScreen"
              >清空筛选项</span>
            </div>
          </div>
        </div>

        <div class="div_1 bc_fff">

          <!-- 服务类型 -->
          <SwitchTabs
            v-model="screenForm.kind"
            :tabs="ServiceMerchantDictRes"
            value-key="key"
            label-key="value"
            desc="服务类型:"
            @change="serviceTypeChange"
          />
        </div>
        <div class="solid_line" />
        <!-- 服务商列表 -->
        <ServiceMerchantShow :list="serviceMerchantDataRes.list">
          <template #inner>
            <ServiceMerchantItem
              v-for="item in serviceMerchantDataRes.list"
              :key="item.id"
              :data="item"
              style="cursor: pointer;"
              @click.native="handleServiceClick(item.id)"
            />
          </template>
        </ServiceMerchantShow>

        <div class="padding_1 d_flex justify_content_c">
          <!--分页-->
          <MyPagination
            :current-page="serviceMerchantDataRes.pageNum"
            :total="serviceMerchantDataRes.total"
            style="margin-top: 8px"
            change-method-name="getServiceMerchantList"
            :that="this"
            layout="total,sizes, prev, pager, next, jumper"
            :page-info="pageInfo"
            :page-sizes="[8]"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwitchTabs from '@/components/base/SwitchTabs.vue'
import { service_merchant_list, portal_cms_dicts } from '@/api/portal'
import MyPagination from '@/components/base/MyPagination.vue'
import { isEmtry } from '@/utils'

import SiteBreadcrumb from '@/components/base/SiteBreadcrumb.vue'
import ServiceMerchantItem from '@/components/template/ServiceMerchantItem.vue'
import ServiceMerchantShow from '@/components/template/ServiceMerchantShow.vue'

export default {
  components: {
    SwitchTabs,
    ServiceMerchantItem,
    MyPagination,
    SiteBreadcrumb,
    ServiceMerchantShow
  },
  data() {
    return {
      pageInfo: {
        page: 1,
        rows: 8
      },
      serviceMerchantDataRes: {},
      ServiceMerchantDictRes: [],
      screenForm: {
        kind: null
      }, // 筛选表单

      dynamicTabs: [] // 动态tabs项
    }
  },
  computed: {
  },
  watch: {
    'screenForm.kind': function(n, o) {
      this.screenForm.kind = n === '' ? '' : n
      this.getServiceMerchantList()
    }
  },
  created() {
    this.getServiceMerchantList()
    this.getPortalCmsDicts()
  },
  mounted() {
  },
  methods: {
    // 获取服务商列表 api
    async getServiceMerchantList() {
      const { data } = await service_merchant_list(
        {
          ...this.screenForm,
          ...this.pageInfo
        }
      )
      if (!data) {
        this.serviceMerchantDataRes = {
          list: [],
          pageNum: 0,
          pageSize: 0,
          total: 0
        }
        return
      }
      this.serviceMerchantDataRes = data
    },

    async getPortalCmsDicts() {
      const { data } = await portal_cms_dicts(
        {
          dictType: 'facilitator_kind'
        }
      )
      this.ServiceMerchantDictRes = data
    },

    // 前往服务商详情 click
    handleServiceClick(id) {
      this.$router.push({
        name: 'serviceDetail',
        query: {
          id
        }
      })
    },

    // 服务类型 change
    serviceTypeChange(tab) {
      this.setDynamicTabs(tab, 'kind')
    },

    // 设置动态tabs
    setDynamicTabs(tab, tabType) {
      this.pageInfo.page = 1
      this.dynamicTabs = this.dynamicTabs.filter(item => item.tabType !== tabType)
      if (isEmtry(tab)) return
      tab.tabType = tabType
      this.dynamicTabs.push(tab)
    },

    // 设置动态tabs项value
    setDynamicTabsVal(tabType) {
      this.screenForm[tabType] = null
      this.setDynamicTabs(null, tabType)
      this.getServiceMerchantList()
    },
    // 清空筛选项 click
    clearScreen() {
      this.screenForm.kind = null
      this.dynamicTabs = []
      this.getServiceMerchantList()
    }
  }
}
</script>

<style lang="scss" scoped>
.biddinghall_w {
  .dynamic_tabs_w {
    margin: 0 10px 0 0;
    .d_tab_i {
      border: 1px solid #e6e6e6;
      margin: 0 10px 0 0;
      padding: 5px 10px;
      &:hover {
        cursor: pointer;
        color: #0983cc;
      }
      .icon_i {
        border-radius: 50%;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        &:hover {
          background-color: #c0c4cc;
          color: #fff;
        }
      }
    }
  }
  .div_1 {
    border: 1px solid #e6e6e6;
  }
  ::v-deep .div_2 {
    padding: 17px 10px 0 10px;
    .tabs_w {
      padding: 0;
      .tab_i {
        margin: 0 0 17px 0;
      }
    }
  }
  .div_3 {
    flex: 1;
  }
  .solid_line{
    margin-bottom: 10px;
  }
  .other_screen_w {
    padding: 10px;
    margin: 10px 0;
    border: 1px solid #e6e6e6;
    .screen_i {
      padding: 10px 28px;
      font-size: 12px;

      color: #1a1a1a;
      border: 1px solid #e6e6e6;
      &:nth-child(even) {
        border-right: 0;
        border-left: 0;
      }
      &:hover {
        cursor: pointer;
        background-color: rgba($color: #e6e6e6, $alpha: 0.5);
      }
    }
  }

  ::v-deep .el-pagination__sizes {
    display: none !important;
  }
  ::v-deep .el-breadcrumb {
    display: flex;
  }
  ::v-deep .el-breadcrumb__item,
  ::v-deep .el-breadcrumb__inner {
    display: flex;
    align-items: center;
  }
  .padding_1 {
    padding: 21px 0;
  }
  .span_1 {
    margin: 0 20px 0 0;
  }
  .span_2 {
    padding: 6px 20px;
  }
  .content_w {
    padding-top: 20px;
  }
  .screen_w {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    padding: 11px 21px;
    margin: 35px 0 0 0;
  }
}
</style>
